// Utility.js
function sanitizeInput(input) {

    // Remove or replace characters that could be used in injection attacks
    const sanitizedInput = input.replace(/[<>"'&]/g, ''); // Replace characters like <, >, ", ', &
    return sanitizedInput;
  }
  
  export default sanitizeInput;
  